import {
  Box,
  RadioButtonGroupMapping,
  RadioButtonType,
  RadioButtons,
} from '@labrav/react-components'
import { KeyValue } from '../../../../modules/privateOffer/privateOfferCreation/types'
import {
  AgreementDurationType,
  DiscountType,
} from '../../../../admin/modules/resaleAuthorizations'
import React, { useCallback, useEffect } from 'react'

import { getKeyFromValue } from '../../../../common/utils/getKeyFromValue'
import { useStyles } from './AuthorizationDuration.styles'
import { FormField } from '@labrav/react-components/lib/@types/types/forms'
import { isEmpty } from 'lodash'
import { ExpirationDate } from '../../../PrivateOfferForm/Details/ExpirationDate'
import { disableResaleAuthorizationDurationText } from '../../constants'

export type AuthorizationDurationProps = {
  handleChange: (data: KeyValue) => void
  agreementDurationType: AgreementDurationType
  agreementExpirationDate: string
  error: string
  discountType: DiscountType
}
export const AuthorizationDuration = React.memo(
  ({
    handleChange,
    agreementDurationType,
    agreementExpirationDate,
    discountType,
  }: AuthorizationDurationProps) => {
    const { classes } = useStyles()
    const isFlexiblePaymentDiscountType =
      discountType === DiscountType.FLEXIBLE_PAYMENT_TERMS

    const authorizationDurationMapping: RadioButtonGroupMapping[] = [
      {
        key: AgreementDurationType.SINGLE_USE,
        label: 'Single use',
        type: RadioButtonType.STANDARD,
      },
      {
        key: AgreementDurationType.SPECIFIC_TIME,
        label: `Specific time duration ${
          isFlexiblePaymentDiscountType
            ? disableResaleAuthorizationDurationText
            : ''
        }`,
        type: RadioButtonType.STANDARD,
        disabled: isFlexiblePaymentDiscountType,
      },
      {
        key: AgreementDurationType.NO_SET_TIME,
        label: `No set time duration ${
          isFlexiblePaymentDiscountType
            ? disableResaleAuthorizationDurationText
            : ''
        }`,
        type: RadioButtonType.STANDARD,
        disabled: isFlexiblePaymentDiscountType,
      },
    ]

    useEffect(() => {
      if (agreementDurationType === AgreementDurationType.NO_SET_TIME) {
        handleChange({
          key: 'agreementExpirationDate',
          value: '',
        })
      }
    }, [agreementDurationType])

    const handleUpdate = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        handleChange({
          key: 'agreementDurationType',
          value: (event.target as HTMLInputElement).value,
        })
      },
      [agreementDurationType]
    )

    const field: FormField = {
      title: 'End date',
      humanReadableKey: 'End date',
      placeHolder: 'End date',
      id: 'agreementExpirationDate',
      isRequired: true,
      isReadOnly: false,
      isCustom: false,
      defaultValue: !isEmpty(agreementExpirationDate)
        ? agreementExpirationDate.split('T')[0]
        : undefined,
      dataType: 'date',
      minDate: 'today',
    }
    return (
      <Box
        tooltipLabel=""
        heading="Authorization duration"
        subHeading={'Authorization time length'}
      >
        <div className={classes.container} data-testid="duration-container">
          <RadioButtons
            checkedValue={{
              key: getKeyFromValue(agreementDurationType)(
                AgreementDurationType
              ) as string,
              value: agreementDurationType,
            }}
            handleChange={handleUpdate}
            radioButtonMappings={authorizationDurationMapping}
          />
          {agreementDurationType !== AgreementDurationType.NO_SET_TIME && (
            <div className={classes.container} key={'expiration'}>
              <ExpirationDate
                handleUpdateExpiration={handleChange}
                field={field}
              />
            </div>
          )}
        </div>
      </Box>
    )
  }
)
